export default () => (
  /**
   * Icone de uma lixeira.
   * Responsável por apagar coordenadas ou geometrias no mapa.
   * Encontrado nas ferramentas de inserir coordenadas e inserir geometrias.
   */
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.81623 1.64773H5.19123V1.27273C5.19123 0.776926 5.59315 0.375 6.08896 0.375H8.63441C9.13021 0.375 9.53214 0.776926 9.53214 1.27273V1.64773H9.90714H13.089C13.2333 1.64773 13.3503 1.76474 13.3503 1.90909V3.18182C13.3503 3.32617 13.2333 3.44318 13.089 3.44318H12.4526H12.0776V3.81818V12.7273C12.0776 13.2231 11.6757 13.625 11.1799 13.625H3.5435C3.0477 13.625 2.64577 13.2231 2.64577 12.7273V3.81818V3.44318H2.27077H1.63441C1.49006 3.44318 1.37305 3.32617 1.37305 3.18182V1.90909C1.37305 1.76474 1.49006 1.64773 1.63441 1.64773H4.81623ZM5.45259 4.71591C4.89403 4.71591 4.44123 5.16871 4.44123 5.72727V10.8182C4.44123 11.3767 4.89403 11.8295 5.45259 11.8295C6.01115 11.8295 6.46396 11.3767 6.46396 10.8182V5.72727C6.46396 5.16871 6.01115 4.71591 5.45259 4.71591ZM9.27077 4.71591C8.71221 4.71591 8.25941 5.16871 8.25941 5.72727V10.8182C8.25941 11.3767 8.71221 11.8295 9.27077 11.8295C9.82933 11.8295 10.2821 11.3767 10.2821 10.8182V5.72727C10.2821 5.16871 9.82933 4.71591 9.27077 4.71591Z"
      stroke="#BEC7DC"
      strokeWidth="0.75"
    />
  </svg>
);
